import { postTrack } from "./api";

export function track(event, data = {}) {
  postTrack({
    event,
    path: window.location.pathname,
    device: window.innerWidth < 768 ? "mobile" : "desktop",
    ...data,
  });
}
